import { IClient, UserDetailsResponse } from './types';
import { ReactEnvironments } from './constants';

export const API_ENV: string =
  process.env.REACT_APP_ENV || ReactEnvironments.Develop;


export const getDefaultStore = (userinfo: UserDetailsResponse): string => {
  const defaultStore = userinfo?.iamUser?.assignments?.[0].stores?.find(
    (store: any) => store.defaultStore,
  );
  return defaultStore?.storeId || '';
};

export type ObjectTypes = {
  [key: string]: string;
};

export const getAPIBffBase = (
  env: string = ReactEnvironments.Develop
): string => {
  switch (env) {
    case ReactEnvironments.Production:
      return 'https://svc-truck-dms-post-to-oem.ext.nebula.connectcdk.com/truck-dms-post-to-oem/v1';
    case ReactEnvironments.Staging:
      return 'https://svc-truck-dms-post-to-oem.ext.nebula-stage.connectcdk.com/truck-dms-post-to-oem/v1';
    case ReactEnvironments.Perf:
      return 'https://svc-truck-dms-post-to-oem.ext.nebula-perf.connectcdk.com/truck-dms-post-to-oem/v1';
    case ReactEnvironments.Local:
      return 'http://localhost:8080';
    case ReactEnvironments.Develop:
    default:
      return 'https://svc-truck-dms-post-to-oem.ext.nebula-dev.connectcdk.com/truck-dms-post-to-oem/v1';
  }
};

export const getCommonUserDetails = (
  env: string = ReactEnvironments.Develop
): string => {
  switch (env) {
    case ReactEnvironments.Production:
      return 'https://dms-ui-common-bff-jwt.na.connectcdk.com';
    case ReactEnvironments.Staging:
      return 'https://dms-ui-common-bff-jwt.na-dev.connectcdk.com';
    case ReactEnvironments.Perf:
      return 'https://dms-ui-common-bff-jwt.na-dev.connectcdk.com';
    case ReactEnvironments.Local:
      return 'http://localhost:8080';
    case ReactEnvironments.Develop:
    default:
      return 'https://dms-ui-common-bff-jwt.na-dev.connectcdk.com';
      
  }
};

export const DTNA_PPOE_BFF: ObjectTypes = {
  [ReactEnvironments.Local]: `dtna-ppoe-bff`,
  [ReactEnvironments.Develop]: `dtna-ppoe-bff`,
  [ReactEnvironments.Staging]: `dtna-ppoe-bff`,
  [ReactEnvironments.Perf]: `dtna-ppoe-bff`,
  [ReactEnvironments.Production]: `dtna-ppoe-bff`
};


const PPOE_USER_DETAILS = `${getCommonUserDetails(API_ENV)}`;


export const PATHS = {
  USER_DETAILS: `${PPOE_USER_DETAILS}/user/details/with-account-type/I`,
  GET_ORDERS:`${getAPIBffBase(API_ENV)}` + "/orderHistory",
  GET_DMS_ORDERS:`${getAPIBffBase(API_ENV)}` + "/orders",
  SUBMIT_ORDERS: `${getAPIBffBase(API_ENV)}` + "/postData",
  GET_ORDER_STATUS:`${getAPIBffBase(API_ENV)}` + "/status",
  GET_DROPDOWNDATA:`${getAPIBffBase(API_ENV)}` + "/dropdown-data/",
  GET_ORDERDETAILS:`${getAPIBffBase(API_ENV)}`+"/orderDetails"
};



export const getDepartmentByStore = (
  userinfo: UserDetailsResponse,
  storeId: string,
): string => {
  const departmentName = userinfo?.extendedAccountInfo?.find(
    (department) => department.storeId === storeId,
  );

  return departmentName?.accounts?.[0] || '';
};

export const isClientReady = (clientObject: IClient): boolean => clientObject.headers.authorization !== ''
  && clientObject.headers['x-enterprise-id'] !== ''
  && clientObject.headers['x-store-id'] !== ''
  && clientObject.headers.remote_user !== ''
  && clientObject.headers['x-department-name'] !== '';